import React, { useState } from "react";
import "./Footer.css";
import { Link } from "react-router-dom"
import {Facebook, Instagram, Twitter, Linkedin, HelpCircle} from "lucide-react"
import { suggest } from "../../services/controlPanelApi";
import { toast } from "react-toastify";
import LegalModal from "../LegalAspects/LegalModal";
import ThemeToggle from "./ThemeToggle"; // Importamos el componente ThemeToggle

const Footer = () => {
    const [modalType, setModalType] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [formData, setFormData] = useState({ type: "", suggestion: "" });
    const [error, setError] = useState("");
    const [legalModal, setLegalModal] = useState({
        isOpen: false,
        contentType: null,
        title: ""
    });

    const currentYear = new Date().getFullYear();

    const openModal = (type) => {
        setFormData({ type: type === "Otra" ? "" : type, suggestion: "" });
        setModalType(type);
        setModalOpen(true);
        setError("");
    };

    const closeModal = () => {
        setModalOpen(false);
        setFormData({ type: "", suggestion: "" });
        setModalType(null);
        setError("");
    };

    const openLegalModal = (contentType, title) => {
        setLegalModal({
            isOpen: true,
            contentType,
            title
        });
    };

    const closeLegalModal = () => {
        setLegalModal({
            isOpen: false,
            contentType: null,
            title: ""
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        if (!formData.type || !formData.suggestion) {
            setError("Ambos campos son obligatorios.");
            return;
        }
        try {
            await suggest(formData);
            toast.success("Sugerencia enviada con éxito.");
            setFormData({ type: "", suggestion: "" });
            setModalOpen(false);
        } catch (err) {
            toast.error("Error al enviar la sugerencia.");
        }
    };

    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };

    return (
        <footer className="site-footer">
            <div className="footer-container">
                <div className="footer-row">
                    <div className="footer-col about-col">
                        <h4>Sobre Nosotros</h4>
                        <p>
                            <span>CONTACTAME</span> fue creado para centralizar en un solo lugar todos los contactos que
                            uno podría requerir. En pocos clicks, podrás encontrar el contacto de cualquier empresa
                            o profesional que necesites.
                        </p>
                        <Link
                            to="/preguntas-frecuentes"
                            className="btn-suggestion faq-btn"
                            style={{ marginTop: '1rem', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}
                        >
                            <HelpCircle size={16} />
                            Preguntas Frecuentes
                        </Link>
                    </div>

                    <div className="footer-col links-col">
                        <h4>Enlaces Útiles</h4>
                        <ul>
                            <li>
                                <Link to="/categorias/servicios">Servicios</Link>
                            </li>
                            <li>
                                <Link to="/categorias/productos">Productos</Link>
                            </li>
                            <li>
                                <a
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        openLegalModal("terms", "Términos y Condiciones");
                                    }}
                                >
                                    Términos y Condiciones
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        openLegalModal("privacy", "Política de Privacidad");
                                    }}
                                >
                                    Política de Privacidad
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="footer-col links-col">
                        <h4 onClick={() => openModal(null)} style={{cursor: 'pointer'}}>
                            ¿Tenés una sugerencia?
                        </h4>
                        <ul style={{cursor: 'pointer', color:"b0b0b0"}}>
                            <li onClick={() => openModal("Category")}>Nueva categoría</li>
                            <li onClick={() => openModal("Location")}>Nueva localidad</li>
                            <li onClick={() => openModal("Other")}>Otra sugerencia</li>
                        </ul>
                    </div>

                    <div className="footer-col social-col">
                        <h4>Síguenos</h4>
                        <div className="social-links">
                            <a href="https://facebook.com/share/1GxgBYygRK" target="_blank" rel="noopener noreferrer"
                               aria-label="Facebook">
                                <Facebook size={20}/>
                            </a>
                            <a href="https://instagram.com/contactame.com.ar" target="_blank" rel="noopener noreferrer"
                               aria-label="Instagram">
                                <Instagram size={20}/>
                            </a>
                            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"
                               aria-label="Twitter">
                                <Twitter size={20}/>
                            </a>
                            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"
                               aria-label="LinkedIn">
                                <Linkedin size={20}/>
                            </a>
                        </div>
                    </div>
                </div>

                <div className="footer-divider"></div>

                {/* Agregamos el ThemeToggle antes del footer-bottom para dispositivos móviles */}
                <div className="theme-toggle-mobile">
                    <ThemeToggle />
                </div>

                <div className="footer-bottom">
                    <p><span>&copy; {currentYear} CONTACTAME</span>. Todos los derechos reservados.</p>
                    {/* Agregamos el ThemeToggle aquí para pantallas grandes */}
                    <div className="theme-toggle-desktop">
                        <ThemeToggle />
                    </div>
                </div>
            </div>

            {modalOpen && (
                <div className="suggestion-modal-backdrop">
                    <div className="suggestion-modal">
                        <button className="close-btn" onClick={closeModal}>×</button>
                        <h2>Enviar Sugerencia</h2>

                        {error && <p className="error">{error}</p>}

                        <form onSubmit={handleSubmit}>
                            <label>Tipo</label>
                            <select
                                value={formData.type}
                                onChange={(e) => handleChange("type", e.target.value)}
                                required
                            >
                                <option value="">Seleccioná una opción</option>
                                <option value="Category">Categoría</option>
                                <option value="Location">Localidad</option>
                                <option value="Other">Otra</option>
                            </select>

                            <label>Sugerencia</label>
                            <textarea
                                rows={3}
                                value={formData.suggestion}
                                onChange={(e) => handleChange("suggestion", e.target.value)}
                                placeholder="Escribí tu sugerencia aquí..."
                                required
                            />

                            <button className="btn btn-red" type="submit">Enviar</button>
                        </form>
                    </div>
                </div>
            )}

            {/* Modal para términos y condiciones o política de privacidad */}
            <LegalModal
                isOpen={legalModal.isOpen}
                onClose={closeLegalModal}
                title={legalModal.title}
                contentType={legalModal.contentType}
            />
        </footer>
    )
}

export default Footer